// extracted by mini-css-extract-plugin
export var arrow = "VideoViewer-module--arrow--19e33";
export var arrowNo = "VideoViewer-module--arrow_no--c0dff";
export var arrowYes = "VideoViewer-module--arrow_yes--0a453";
export var closeOverlayButton = "VideoViewer-module--closeOverlayButton--58454";
export var closeOverlayIcon = "VideoViewer-module--closeOverlayIcon--5dd8e";
export var contentContainer = "VideoViewer-module--contentContainer--2f686";
export var controlsContainer = "VideoViewer-module--controlsContainer--b67e3";
export var currentPageIndicator = "VideoViewer-module--currentPageIndicator--4adbb";
export var documentAbstract = "VideoViewer-module--documentAbstract--bf608";
export var documentImage = "VideoViewer-module--documentImage--7772b";
export var documentInformationColumn = "VideoViewer-module--documentInformationColumn--8ed68";
export var documentInformationContainer = "VideoViewer-module--documentInformationContainer--77c01";
export var documentTitle = "VideoViewer-module--documentTitle--8b636";
export var downloadContainer = "VideoViewer-module--downloadContainer--92eb5";
export var downloadDocumentButton = "VideoViewer-module--downloadDocumentButton--d3938";
export var expandTranscriptLabelContainer = "VideoViewer-module--expandTranscriptLabelContainer--c8a5d";
export var expandTranscriptOverlay = "VideoViewer-module--expandTranscriptOverlay--974a0";
export var expanded = "VideoViewer-module--expanded--d26c5";
export var fileInformation = "VideoViewer-module--fileInformation--c49a7";
export var flex = "VideoViewer-module--flex--d1ddd";
export var flex1 = "VideoViewer-module--flex_1--dec13";
export var flexCenter = "VideoViewer-module--flex_center--22aef";
export var flexCenterCol = "VideoViewer-module--flex_center_col--1e0aa";
export var flexCol = "VideoViewer-module--flex_col--f7829";
export var flexFixCenterCol = "VideoViewer-module--flex_fix_center_col--34b40";
export var flexFixedCenterCol = "VideoViewer-module--flex_fixed_center_col--d12d1";
export var informationItem = "VideoViewer-module--informationItem--ae127";
export var informationItemLabel = "VideoViewer-module--informationItemLabel--94b2d";
export var informationKeywordItem = "VideoViewer-module--informationKeywordItem--4363d";
export var informationKeywordItemWrapper = "VideoViewer-module--informationKeywordItemWrapper--77e46";
export var navigationButton = "VideoViewer-module--navigationButton--f1db1";
export var nextPageButton = "VideoViewer-module--nextPageButton--cf45b";
export var nextPageIcon = "VideoViewer-module--nextPageIcon--790fc";
export var pageControlContainer = "VideoViewer-module--pageControlContainer--0235a";
export var previousPageButton = "VideoViewer-module--previousPageButton--a35a4";
export var previousPageIcon = "VideoViewer-module--previousPageIcon--e733d";
export var provider = "VideoViewer-module--provider--b7fe3";
export var providerText = "VideoViewer-module--providerText--08087";
export var rotating = "VideoViewer-module--rotating--1951a";
export var shareContainer = "VideoViewer-module--shareContainer--39b6c";
export var toggleTranscript = "VideoViewer-module--toggleTranscript--300e9";
export var toggleTranscriptIcon = "VideoViewer-module--toggleTranscriptIcon--f1b1c";
export var transcriptContainer = "VideoViewer-module--transcriptContainer--0c0a4";
export var videoContainer = "VideoViewer-module--videoContainer--68691";
export var viewerContainer = "VideoViewer-module--viewerContainer--0efb1";
export var visible = "VideoViewer-module--visible--41a78";
export var wysiwyg = "VideoViewer-module--wysiwyg--dd3fa";